import { gql } from '@apollo/client';

export const fetchPartnerAccounts = gql`
  query fetchPartnerAccounts($email: String, $query: String, $searchOptions: SearchOptions) {
    fetchPartnerAccounts(email: $email, query: $query, searchOptions: $searchOptions) {
      totalHits
      results {
        id
        name
        contactAccountRole {
          roles
        }
        domains {
          main
          alternates
        }
        programLevelGlobal
      }
    }
  }
`;
